import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSizeXl = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 33.195 33.195",
	fill: "currentColor",
	stroke: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "XL_Banner",
		transform: "translate(6442 21323)",
		children: [/* @__PURE__ */ _jsx("g", {
			id: "Group_184",
			"data-name": "Group 184",
			transform: "translate(-6442 -21323)",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_211",
				"data-name": "Path 211",
				d: "M30.429,1.383a1.307,1.307,0,0,1,1.383,1.383V30.429a1.307,1.307,0,0,1-1.383,1.383H2.766a1.307,1.307,0,0,1-1.383-1.383V2.766A1.307,1.307,0,0,1,2.766,1.383H30.429m0-1.383H2.766A2.774,2.774,0,0,0,0,2.766V30.429a2.774,2.774,0,0,0,2.766,2.766H30.429a2.774,2.774,0,0,0,2.766-2.766V2.766A2.774,2.774,0,0,0,30.429,0Z"
			})
		}), /* @__PURE__ */ _jsx("path", {
			id: "Path_2714",
			"data-name": "Path 2714",
			d: "M4.791-4.091,6.819-7.82H9.382L6.232-2.457,9.464,3H6.871L4.791-.793,2.711,3H.118L3.35-2.457.2-7.82H2.763Zm8.023,5.3h4.732V3H10.585V-7.82h2.229Z",
			transform: "translate(-6434.313 -21303.945)"
		})]
	})
});
export default SvgSizeXl;
